jQuery(document).ready(function($){

   /* ==========================================================================
   == CALCUL WIDTH ==
   ========================================================================== */

   var winW=0;
   function detectionWindow(){
      if(document.documentElement&&(document.documentElement.clientWidth||document.documentElement.clientHeight)){
         winW=document.documentElement.clientWidth;
      }else if(document.body&&(document.body.clientWidth||document.body.clientHeight)){
         winW=document.body.clientWidth
      }
   }
   detectionWindow();






   /* ==========================================================================
   == MENU RESPONSIVE ==
   ========================================================================== */

   $('.menu-toggle').click(function(){
      $(".menu").toggleClass('active');
   });


   /* ==========================================================================
   == HEADER FIXED ==
   ========================================================================== */

   if(winW > 767) {
      $('.header-nav').scrollToFixed();
   }

   /* ==========================================================================
   == SLIDER ==
   ========================================================================== */

   var swiper = new Swiper('.slider', {
      autoplay: 2500,
      speed: 1000,
      effect: 'fade',
      loop: true
   });

   var swiper = new Swiper('.tem-slider', {
      slidesPerView: 1,
      autoplay: 2500,
      autoplayDisableOnInteraction: true,
      loop: true,
      pagination: '.swiper-pagination',
      paginationClickable: true
   });

   var swiper_carousel = new Swiper('.carousel', {
      pagination: true,
      nextButton: '.swiper-button-next',
      prevButton: '.swiper-button-prev',
      slidesPerView: 3,
      paginationClickable: true,
      spaceBetween: 10,
      loop: true,
      breakpoints: {
         768: {
            slidesPerView: 1,
            pagination: '.swiper-pagination-carousel'
         }
      }
   });






    /* ==========================================================================
    == RECHERCHE ==
    ========================================================================== */

    $(".search-arrow").click(function(){
    	$(this).parent().find("select").click();
    });

    if ($.fn.pickadate && $(".search-form").length ) {

            $('#dt-deb').pickadate({
                   format: 'dd/mm/yyyy',
                   formatSubmit: 'dd/mm/yyyy',
                   hiddenName: true,
                   firstDay: 1,
                   min: true,
                   container: '.search-form'
               });

            $('#dt-fin').pickadate({
                format: 'dd/mm/yyyy',
                formatSubmit: 'dd/mm/yyyy',
                hiddenName: true,
                firstDay: 1,
                min: true,
                container: '.search-form'
            });

            var from_$input = $('#dt-deb').pickadate(),
                  from_picker = from_$input.pickadate('picker')

            var to_$input = $('#dt-fin').pickadate(),
                  to_picker = to_$input.pickadate('picker')


            // Check if there’s a “from” or “to” date to start with.
            if ( from_picker.get('value') ) {
               to_picker.set('min', from_picker.get('select'))
            }
            if ( to_picker.get('value') ) {
               from_picker.set('max', to_picker.get('select'))
            }

            // When something is selected, update the “from” and “to” limits.
            from_picker.on('set', function(event) {
               if ( event.select ) {
                  to_picker.set('min', from_picker.get('select'))
               }
               else if ( 'clear' in event ) {
                  to_picker.set('min', false)
               }
            })
            to_picker.on('set', function(event) {
               if ( event.select ) {
                  from_picker.set('max', to_picker.get('select'))
               }
               else if ( 'clear' in event ) {
                  from_picker.set('max', false)
               }
            })



    }


    /* ==========================================================================
    == INSCRIPTIONS ==
    ========================================================================== */

    $('.prog-item-btn').click(function(){
        console.log($(this).data);
        var retraite = $(this);
        var ref = retraite.data("ref");
        if( ref ){
        	ref = "<br><br>Référence : " + ref;
        }
        $("#retraite").val(retraite.data("titre") + " - du " + retraite.data("deb") + " au " + retraite.data("fin")  );
        $("#lightbox-form-inscription-titre").html( retraite.data("titre"));
        $("#lightbox-form-inscription-dates").html( "du " + retraite.data("deb") + "<br> au " + retraite.data("fin") + ref );
        $("#retraitereference").val(retraite.data("ref"));
    });


    /* ==========================================================================
    == ACCORDIONS ==
    ========================================================================== */

    $(".acc-ttl").click(function(){
        $(this).parent(".acc-item").find(".acc-content").toggle("fast");
    });

    if( $(".acc").length ) {
      if(window.location.hash) {
         var ancre = window.location.hash.substring(1);
         $("#"+ancre).addClass("open");
      }
   }


/* ==========================================================================
   == VIDEO LIGHTBOX ==
   ========================================================================== */

   $(".tem-card, .tem-all").on('click', function(ev) {
    	var id_video = $(this).data('featherlightPerso');
   	$.featherlight(id_video);
      var urlvideo = $(this).data('urlvideo');
      if( urlvideo ){
	      $(".featherlight " + id_video).html('<iframe src="'+urlvideo+'" frameborder="0" allowfullscreen></iframe>');
      }
      //ev.preventDefault();

   });








   // ------------------------------------------
   // -- NAVIGATION STEPS BAR INSCRIPTION
   // ------------------------------------------

   $(".form__step").click(function(e){
      document.location.assign('?step=' + $(this).val());
   });

   $("[name='ins-cat']").change(function(e){
      if( $(this).val() == 'individuel' ){
         $("#ins-nbr-adulte").val("1");
         $("#ins-nbr-enfant").val("0");
      }
      if( $(this).val() == 'couple' ){
         $("#ins-nbr-adulte").val("2");
         $("#ins-nbr-enfant").val("0");
      }
      if( $(this).val() == 'famille' ){
         $("#ins-nbr-adulte").val("");
         $("#ins-nbr-enfant").val("");
      }
      if( $(this).val() == 'enfant' ){
         $("#ins-nbr-adulte").val("0");
         $("#ins-nbr-enfant").val("");
      }
   });


   $("[name='same_adresse']").change(function(e){
      if( $(this).val() == 1 ){
          $("#js__adresseadulte2").attr("hidden","");
          $("#js__adresseadulte2").find("input").removeAttr("required");
      }else{
          $("#js__adresseadulte2").removeAttr("hidden");
          $("#js__adresseadulte2").find("input").attr("required","");
      }

   });

   // ------------------------------------------
   // -- HOME - VIDEO PLAYER
   // ------------------------------------------

   $('.video__toggle--play').click(playVideo);
   $('.video__toggle--pause').click(playVideo);

   $('.video__speaker--on').click(soundVideo);
   $('.video__speaker--off').click(soundVideo);

   function playVideo () {
      $('.video__toggle--play').toggleClass('video__btn--hidden');
      $('.video__toggle--pause').toggleClass('video__btn--hidden');

      if ($('.video__player').get(0).paused) {
         $('.video__player').get(0).play();
      } else {
         $('.video__player').get(0).pause();
      }
   }

   function soundVideo () {
      $('.video__speaker--on').toggleClass('video__btn--hidden');
      $('.video__speaker--off').toggleClass('video__btn--hidden');

      if ($('.video__player').prop('muted')) {
         $('.video__player').prop('muted', false);
      } else {
         $('.video__player').prop('muted', true);
      }
   }

   // -----------------------------------------------------
   // -- INSCRIPTION : Gestion du choix autre
   // -----------------------------------------------------
   $(".js__other").on("change", function() {
      var target = $("#" + $(this).data("other"));
      var isOther = false;

      if ($(this).is("select")) {
         isOther = $(this).val() === "autre";
      } else if ($(this).is(":checkbox")) {
         isOther = $(this).is(":checked");
      }

      target.prop("hidden", !isOther);

      if (!isOther) {
         target.find("input, textarea, select").val("");
      }
   });

   // -----------------------------------------------------
   // -- INSCRIPTION : Gestion du choix covoiturage
   // -----------------------------------------------------
   $(".js__covoit").on("change", function() {
      var target = $("#" + $(this).data("covoit"));
      var isOther = false;

      if ($(this).is("select")) {
         isOther = $(this).val() === "covoit";
      } else if ($(this).is(":checkbox")) {
         isOther = $(this).is(":checked");
      }

      target.prop("hidden", !isOther);

      if (!isOther) {
         target.find("input, textarea, select").val("");
      }
   });

});


